
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWhatsapp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 23,
  viewBox: "0 0 23 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M16.768 13.783c-.287-.144-1.692-.831-1.955-.926-.261-.096-.452-.144-.644.144-.19.283-.738.924-.905 1.114-.167.19-.334.213-.618.072-.288-.144-1.21-.446-2.303-1.415-.851-.755-1.423-1.687-1.591-1.973-.167-.285-.02-.439.125-.581.129-.13.287-.334.43-.5.142-.167.188-.285.285-.475.095-.191.048-.356-.024-.5-.072-.144-.644-1.544-.883-2.113-.23-.557-.467-.48-.644-.489-.165-.009-.356-.01-.546-.01a1.06 1.06 0 0 0-.765.355c-.261.288-1 .975-1 2.376 0 1.402 1.025 2.756 1.167 2.947.144.19 2.018 3.066 4.888 4.298.684.295 1.216.47 1.633.601.684.216 1.308.187 1.8.115.551-.083 1.694-.69 1.933-1.356.24-.665.24-1.236.168-1.355-.072-.12-.262-.191-.55-.334m-5.22 7.094h-.006a9.537 9.537 0 0 1-4.844-1.32l-.345-.205-3.604.94.963-3.493-.23-.36a9.403 9.403 0 0 1-1.452-5.042c0-5.222 4.27-9.473 9.52-9.473a9.482 9.482 0 0 1 6.728 2.78 9.385 9.385 0 0 1 2.789 6.702c-.004 5.222-4.274 9.473-9.52 9.473m8.101-17.538A11.445 11.445 0 0 0 11.546 0C5.236 0 .101 5.112.096 11.396c0 2.009.526 3.968 1.528 5.699L0 23l6.07-1.584a11.53 11.53 0 0 0 5.473 1.387h.006c6.31 0 11.448-5.113 11.451-11.4 0-3.043-1.189-5.907-3.35-8.06",
  fillRule: "evenodd"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"23\" height=\"23\" viewBox=\"0 0 23 23\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path fill=\"var(--theme-primary, #810ea9)\" d=\"M16.768 13.783c-.287-.144-1.692-.831-1.955-.926-.261-.096-.452-.144-.644.144-.19.283-.738.924-.905 1.114-.167.19-.334.213-.618.072-.288-.144-1.21-.446-2.303-1.415-.851-.755-1.423-1.687-1.591-1.973-.167-.285-.02-.439.125-.581.129-.13.287-.334.43-.5.142-.167.188-.285.285-.475.095-.191.048-.356-.024-.5-.072-.144-.644-1.544-.883-2.113-.23-.557-.467-.48-.644-.489-.165-.009-.356-.01-.546-.01-.192 0-.503.072-.765.355-.261.288-1 .975-1 2.376 0 1.402 1.025 2.756 1.167 2.947.144.19 2.018 3.066 4.888 4.298.684.295 1.216.47 1.633.601.684.216 1.308.187 1.8.115.551-.083 1.694-.69 1.933-1.356.24-.665.24-1.236.168-1.355-.072-.12-.262-.191-.55-.334m-5.22 7.094h-.006c-1.706 0-3.382-.457-4.844-1.32l-.345-.205-3.604.94.963-3.493-.23-.36c-.952-1.508-1.455-3.252-1.452-5.042 0-5.222 4.27-9.473 9.52-9.473 2.545.003 4.931.99 6.728 2.78 1.8 1.79 2.789 4.169 2.789 6.702-.004 5.222-4.274 9.473-9.52 9.473m8.101-17.538C17.486 1.19 14.611.003 11.546 0 5.236 0 .101 5.112.096 11.396c0 2.009.526 3.968 1.528 5.699L0 23l6.07-1.584c1.674.905 3.557 1.386 5.473 1.387h.006c6.31 0 11.448-5.113 11.451-11.4 0-3.043-1.189-5.907-3.35-8.06\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/whatsapp.88ce2d443f349f3abb0c68dccd3853bd.svg"),
        {
          React: SvgWhatsapp,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      